// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInExistingAccountStyles } from "@sc/Overrides/Widgets/SignIn/SignInExistingAccount";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

signInExistingAccountStyles.wrapper = {
    css: css`
        width: 100%;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        background-color: ${color("white")};
        padding: 32px;
    `,
};

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        padding-top: 12px;
    `,
};

signInExistingAccountStyles.rememberMeGridItem = {
    ...signInExistingAccountStyles.rememberMeGridItem,
    css: css`
        padding-top: 4px;
    `,
};

signInExistingAccountStyles.forgotPasswordGridItem = {
    ...signInExistingAccountStyles.forgotPasswordGridItem,
    css: css`
        padding-top: 4px;
        justify-content: flex-end;
        align-items: center;
    `,
};

signInExistingAccountStyles.signInButton = {
    sizeVariant: "large",
    size: 32,
    typographyProps: {
        size: 12,
    },
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: 12,
        weight: "bold",
        color: "text.link",
        lineHeight: "14px",
    },
};

signInExistingAccountStyles.resetPasswordModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalBody: css`
            &&& {
                max-width: 450px;
            }
        `,
    },
};

signInExistingAccountStyles.signInGridContainer = {
    gap: 16,
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h2",
    as: "h2",
    css: css`
        margin-bottom: 16px;
    `,
};
